(() => {
  'use strict';

  if (window.moshuluPlpPurchaseControls) return;
  window.moshuluPlpPurchaseControls = true;

  const states = new Map();
  let scheduled = false;

  function isPreorder(variant) {
    return variant?.preorder?.enabled === true &&
      Number.isFinite(variant.inventory_quantity) &&
      variant.inventory_quantity <= 0 &&
      variant.inventory_policy === 'continue';
  }

  function updateForm(form, state) {
    if (
      !form.isConnected ||
      form.dataset.submitting === 'true' ||
      state.error
    ) return;

    const select = form.querySelector('[data-plp-variant]');
    const button = form.querySelector('[data-plp-add]');

    if (!select || !button) return;

    const variant = state.variants.get(select.value);

    const available = Array.from(select.options)
      .filter(option => option.value && !option.disabled)
      .map(option => state.variants.get(option.value))
      .filter(Boolean);

    const preorder = isPreorder(variant);

    const allPreorder =
      available.length > 0 &&
      available.every(isPreorder);

    button.textContent = (variant ? preorder : allPreorder)
      ? 'Pre-order now'
      : 'Add to basket';

    form.querySelectorAll('[data-plp-preorder-property]')
      .forEach(input => input.remove());

    if (preorder) {
      const properties = {
        'Pre-order': ' '
      };

      if (variant.preorder.message) {
        properties['Estimated shipping'] =
          variant.preorder.message;
      }

      Object.entries(properties).forEach(([name, value]) => {
        const input = document.createElement('input');

        input.type = 'hidden';
        input.name = `properties[${name}]`;
        input.value = value;
        input.setAttribute('data-plp-preorder-property', '');

        form.append(input);
      });
    }
  }

  function readState(form) {
    const product = form.closest('[data-plp-dialog-product]');
    const source = product?.querySelector('[data-plp-purchase-data]');

    if (!source) {
      return {
        error: true,
        variants: new Map()
      };
    }

    try {
      const data = JSON.parse(source.textContent || 'null');

      if (
        !Array.isArray(data?.variants) ||
        form.getAttribute('id') !== `plp-quick-form-${data.id}`
      ) {
        throw new Error('Product data does not match');
      }

      const variants = new Map(
        data.variants.map(variant => [
          String(variant.id),
          variant
        ])
      );

      const select = form.querySelector('[data-plp-variant]');

      for (const option of select?.options || []) {
        if (!option.value) continue;

        const variant = variants.get(option.value);

        if (
          !variant ||
          typeof variant.preorder?.enabled !== 'boolean'
        ) {
          throw new Error('Pre-order data unavailable');
        }
      }

      return {
        error: false,
        variants
      };
    } catch (error) {
      return {
        error: true,
        variants: new Map()
      };
    }
  }

  function refresh() {
    scheduled = false;

    for (const form of states.keys()) {
      if (!form.isConnected) {
        states.delete(form);
      }
    }

    document.querySelectorAll(
      '.plp-test-dialog .plp-test-form'
    ).forEach(form => {
      if (states.has(form)) return;

      const state = readState(form);

      states.set(form, state);

      if (!state.error) {
        updateForm(form, state);
      }
    });
  }

  function schedule() {
    if (scheduled) return;

    scheduled = true;
    queueMicrotask(refresh);
  }

  document.addEventListener('change', event => {
    if (
      !event.target.matches?.('[data-plp-variant]')
    ) return;

    const form = event.target.closest('.plp-test-form');
    const state = states.get(form);

    if (state) {
      queueMicrotask(() => updateForm(form, state));
    }
  });

  const relevant = '.plp-test-form';

  new MutationObserver(records => {
    records
      .filter(record => record.type === 'attributes')
      .forEach(record => {
        const state = states.get(record.target);

        if (state) {
          updateForm(record.target, state);
        }
      });

    const contentChanged = records.some(record =>
      [...record.addedNodes, ...record.removedNodes]
        .some(node =>
          node.nodeType === 1 &&
          (
            node.matches(relevant) ||
            node.querySelector(relevant)
          )
        )
    );

    if (contentChanged) schedule();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-submitting']
  });

  refresh();
})();